module.exports = {
	colors: {
		main: '#e8201c',
		sec: '#110e0e',
		alt: '#e8201c',
	},

	showFunds: false,
	showBuses: false,
	useBusAssistantGPS: false,
	showHomeworks: false,
	showSchoolDay: false,
	showLanguages: false,
	useCourses: false,
	useUploadChatImage: false,

	about: {
		mobiles: ['+963215224088'],
		phones: [],
		address: 'حلب - المحافظة - خلف مدرسة مريم',
		data: [],
		branches: [],
		email: 'alrowad-ins@hotmail.com',
		facebook: 'https://www.facebook.com/share/18ys5rKMSq/',
		telegram: null,
		privacy: 'https://alrowad-institute.edunixsystem.com/al-rowad-privacy.html',
		details: [
			{
				title: 'من نحن',
				content: [
					'معهد متخصص في تقديم دورات متميزة للشهادة الثانوية بفرعيها العلمي والادبي',
				],
			},
		],
	},

	pwa: {
		name: 'Alrowad Institute',
		shortName: 'Alrowad Institute',
		description: 'Alrowad institute app - portal version for Alrowad institute mobile app.',
	},
};
